// Build My Routine config file.
// Loaded before build-my-routine.js.

var SLOT_PLANS = {
  am_only: [
    { slot: 'cleanser', step: 'Cleanse', label: 'Cleanser' },
    { slot: 'moisturiser', step: 'Hydrate', label: 'Moisturiser' },
    { slot: 'sunscreen', step: 'Protect', label: 'Sunscreen' }
  ],
  pm_only: [
    { slot: 'cleanser', step: 'Cleanse', label: 'Cleanser' },
    { slot: 'serum', step: 'Treat', label: 'Serum' },
    { slot: 'night_cream', step: 'Nourish', label: 'Night cream' }
  ],
  am_plus_pm: [
    { slot: 'cleanser', step: 'Cleanse', label: 'Cleanser' },
    { slot: 'moisturiser', step: 'Hydrate', label: 'Moisturiser' },
    { slot: 'serum', step: 'Treat', label: 'Serum' },
    { slot: 'night_cream', step: 'Nourish', label: 'Night cream' },
    { slot: 'sunscreen', step: 'Protect', label: 'Sunscreen' }
  ]
};

var SLOT_PLANS_PAEDIATRIC = {
  am_only: [
    { slot: 'cleanser', step: 'Cleanse', label: 'Cleanser' },
    { slot: 'moisturiser', step: 'Hydrate', label: 'Moisturiser' },
    { slot: 'sunscreen', step: 'Protect', label: 'Sunscreen' }
  ],
  pm_only: [
    { slot: 'cleanser', step: 'Cleanse', label: 'Cleanser' },
    { slot: 'moisturiser', step: 'Hydrate', label: 'Moisturiser' },
    { slot: 'oil', step: 'Nourish', label: 'Baby oil' }
  ],
  am_plus_pm: [
    { slot: 'cleanser', step: 'Cleanse', label: 'Cleanser' },
    { slot: 'moisturiser', step: 'Hydrate', label: 'Moisturiser' },
    { slot: 'oil', step: 'Nourish', label: 'Baby oil' },
    { slot: 'sunscreen', step: 'Protect', label: 'Sunscreen' }
  ]
};


var PAEDIATRIC_SKIN_PROFILE_LABELS = new Set([
  'Normal',
  'Dry'
]);

var PAEDIATRIC_DRY_BOOST_RE = /(lipikar|stelatopia|cicaplast|cicastela|vitamin\s*barrier|atopic|eczema|cold\s*cream|nourishing|soothing|balm|repair)/i;

var PAEDIATRIC_BALM_RE = /(cicaplast|cicastela|stelatopia\s+emollient\s+balm|vitamin\s+barrier|cold\s+cream|repair\s+balm|soothing\s+balm)/i;

var PAEDIATRIC_ALLERGEN_LABELS = new Set([
  'Fragrance',
  'Essential oils',
  'Chemical sunscreen filters',
  'Mineral sunscreen filters'
]);

var MAKEUP_SLOT_CATEGORY = {
  makeup_1: 'mascara',
  makeup_2: 'palette',
  makeup_3: 'balm',
  makeup_4: 'foundation',
  makeup_5: 'lip',
  makeup_6: 'setting_spray'
};

var CLUSTER_SCORE_LOSS = 25;

var BUDGET_CAPS = {
  under_700: 70000,
  '700_2000': 200000,
  over_2000: null
};

var DEFAULTS = {
  concern: 'Pigmentation / Melasma / Dark Marks',
  skin_profile: 'Combination',
  skin_sensitivity: 'Not Sensitive',
  routine_preference: 'AM + PM',
  budget: '700_2000',
  age: '25-34',
  fitzpatrick: '3'
};

var state = {
  concern: '',
  skin_profile: '',
  skin_sensitivity: '',
  routine_preference: '',
  budget: DEFAULTS.budget,
  age: DEFAULTS.age,
  fitzpatrick: DEFAULTS.fitzpatrick,
  preferred_brands: ['any'],
  current_actives: [],
  topical_steroid_use: 'no',
  recent_isotretinoin: 'no',
  include_makeup: 'no',
  allergies: [],
  treatments: []
};

var FITZ_ROMAN_TO_NUM = {
  i: '1',
  ii: '2',
  iii: '3',
  iv: '4',
  v: '5',
  vi: '6'
};

var AGE_BUTTON_TO_LABEL = {
  '0-12': 'Paediatric (0\u201312)',
  '13-17': 'Teen / Adolescent (13\u201317)',
  '18-24': 'Young adult (18\u201324)',
  '25-34': 'Adult (25\u201334)',
  '35-44': 'Adult (35\u201344)',
  '45-59': 'Adult (45\u201359)',
  '60+': 'Adult (60+)'
};

var CONCERN_ORDER = [
  'Pigmentation / Melasma / Dark Marks',
  'Acne / Breakouts / Congestion',
  'Redness / Rosacea-Prone',
  'Sensitive / Reactive Skin',
  'Dryness / Dehydration',
  'Eczema / Barrier Repair',
  'Ageing / Fine Lines / Texture'
];

var SKIN_PROFILE_ORDER = [
  'Normal',
  'Dry',
  'Oily',
  'Combination'
];

var SKIN_SENSITIVITY_ORDER = [
  'Not Sensitive',
  'Moderately Sensitive',
  'Very Sensitive'
];

var ROUTINE_PREFERENCE_ORDER = [
  'AM only',
  'PM only',
  'AM + PM'
];

var CURRENT_ACTIVES_LABELS = [
  'Azelaic acid',
  'Benzoyl peroxide',
  'Glycolic / AHAs',
  'Hydroquinone',
  'Oral antibiotics (doxycycline / minocycline)',
  'Retinol',
  'Roaccutane / Isotretinoin',
  'Salicylic acid',
  'Spironolactone',
  'Topical steroid',
  'Tretinoin / Adapalene / Tazarotene',
  'Vitamin C'
];

var TREATMENT_ORDER = [
  'Chemical peels',
  'Laser / IPL',
  'Microneedling'
];

var ALLERGY_ORDER = [
  'Aspirin',
  'Benzoyl peroxide',
  'Chemical sunscreen filters',
  'Essential oils',
  'Fragrance',
  'Glycolic acid / AHAs',
  'Gluten',
  'Hydroquinone',
  'Lanolin',
  'Mineral sunscreen filters',
  'Nut Allergy',
  'Propylene glycol',
  'Retinoids',
  'Salicylic acid',
  'Vitamin C'
];

console.log('[BuildMyRoutine] config loaded');